import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Store } from "@softline/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  SOFTLINE_CONST_PRODUKTIONSAUFTRAG_REZEPTLISTE,
  SOFTLINE_CONST_PRODUKTIONSAUFTRAG_ZUSATZDATEN,
  SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEAU,
  SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEPR
} from "../../produktionsauftrag.shared";
import { BeweAuStore, BewePrStore } from "../../store";
import { map, Observable, switchMap } from "rxjs";
import { BeweAu, BewePr, Rezeptliste, Zusatzdaten } from "../../types/produktionsauftrag";
import { CommonModule } from "@angular/common";

import { VarDirective } from '@softline/ui-core';
import { BarcodeComponent } from '@softline/ui-core/code';
import { FormatPipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-produktionsauftrag-detail',
    imports: [CommonModule,
    BarcodeComponent,
    FormatPipe,
    TranslatePipe,
    VarDirective],
    templateUrl: './produktionsauftrag-detail.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./produktionsauftrag-detail.component.css']
})
export class ProduktionsauftragDetailComponent implements OnInit, OnDestroy {

  beweau$: Observable<Readonly<BeweAu>> = this.route.queryParamMap
    .pipe(
      map(o => o.get('idbeweau') ?? ''),
      switchMap(id => this.store.observe(
        SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEAU, BeweAuStore.getters.entity, +id)
      ),
    )
  bewepr$: Observable<Readonly<BewePr>> = this.route.paramMap
    .pipe(
      map(o => o.get('id') ?? ''),
      switchMap(id => this.store.observe(
        SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEPR, BewePrStore.getters.entity, +id)
      ),
    )
  zusatzdaten$: Observable<Readonly<Zusatzdaten>> = this.route.paramMap
    .pipe(
      map(o => o.get('id') ?? ''),
      switchMap(id => this.store.observe(
        SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEPR, BewePrStore.getters.detail<'zusatzdaten'>(), {id: +id, name: SOFTLINE_CONST_PRODUKTIONSAUFTRAG_ZUSATZDATEN})
      ),
    )
  rezeptliste$: Observable<Readonly<Rezeptliste>> = this.route.paramMap
    .pipe(
      map(o => o.get('id') ?? ''),
      switchMap(id => this.store.observe(
        SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEPR, BewePrStore.getters.detail<'rezeptliste'>(), {id: +id, name: SOFTLINE_CONST_PRODUKTIONSAUFTRAG_REZEPTLISTE})
      ),
    )

  constructor(private store: Store,
              private router: Router,
              private route: ActivatedRoute) { }


  async ngOnInit(): Promise<void> { }

  ngOnDestroy() { }

}
